import { settings } from "./settings";
import { node } from "./hmcConfig";
import { log } from "./logger";
import { loggerStyle } from "./loggerStyle";

function sameMembers(arr1, arr2) {
  const set1 = new Set(arr1);
  const set2 = new Set(arr2);
  return (
    arr1.every((item) => set2.has(item)) && arr2.every((item) => set1.has(item))
  );
}

function containsAllMembers(arr1, arr2) {
  const containsAll = arr1.every((element) => {
    return arr2.indexOf(element) !== -1;
  });
  return containsAll;
}

function containsAnyMembers(arr1, arr2) {
  const containsAny = arr1.some((element) => {
    return arr2.indexOf(element) !== -1;
  });
  return containsAny;
}

const splitCondition = (exp, delimiter = "anyof") => {
  var test = exp.match(/^{(.*)}\s(anyof|=)\s([\[|\'].*[\]|\'+])$/);
  log(test);
  if (test.length > 1) {
    var testSingleValue = test[3].match(/^'.*'$/);
    if (!!testSingleValue) {
      test[3] = "[" + test[3] + "]";
    }
    return [test[1], JSON.parse(test[3].replace(/'/g, '"')), test[2]];
  }
  return false;
};

const expressionFormatter = (exp, delimiter = "anyof") => {
  const e = {
    or: " or ",
    and: " and ",
    contains: /^{(.*)}\s(contains)\s([\[|\'].*[\]|\'+])$/,
    anyOf: /^{(.*)}\s(anyof)\s([\[|\'].*[\]|\'+])$/,
    regex: /^{(.*)}\s(anyof|=|contains)\s([\[|\'].*[\]|\'+])$/,
  };

  let expAnd = exp.split(e.and);
  let expList = [];
  let expOperator = "";

  expAnd.forEach((el) => {
    expList = [...expList, ...el.split(e.or)];
  });
  if (expAnd.length == expList.length && expAnd.length > 1) {
    expOperator = "and";
  } else {
    expOperator = "or";
  }
  let result = [];
  expList.forEach((el) => {
    var test = el.match(e.regex);

    if (test.length > 1) {
      var testSingleValue = test[3].match(/^'.*'$/);
      if (!!testSingleValue) {
        if (test[3] == "''") test[3] = "[]";
        else test[3] = "[" + test[3] + "]";
      }

      var isAnyOf = e.anyOf.test(el);
      if (isAnyOf) {
        expOperator = "anyof";
        test[2] = "anyof";
      }

      var isContains = e.contains.test(el);
      if (isContains) {
        expOperator = "contains";
        test[2] = "contains";
      }

      result.push([test[1], JSON.parse(test[3].replace(/'/g, '"')), test[2]]);
    }
  });

  return { operator: expOperator, results: result };
};

export const onCompletedShowProductsDL = () => {
  for (
    let i = 0;
    i < settings.form[node.ONCOMPLETED.SHOWPRODUCTS].length;
    i++
  ) {
    const obj = settings.form[node.ONCOMPLETED.SHOWPRODUCTS][i];
    log(obj, loggerStyle.lightgreen);
    const cond = expressionFormatter(obj.expression);
    if (cond) {
      var isMatching = false;
      var isMatchingAll = 0;
      cond.results.forEach((q) => {
        isMatching = false;
        log("condition type: " + q[2], loggerStyle.big.greenOnYellow);
        if (q[2] == "=")
          isMatching = sameMembers(settings.answersMap[q[0]], q[1]);
        if (q[2] == "anyof")
          isMatching = containsAllMembers(settings.answersMap[q[0]], q[1]);
        if (q[2] == "contains")
          isMatching = containsAnyMembers(settings.answersMap[q[0]], q[1]);

        if (isMatching) {
          isMatchingAll++;
        }
      });
      if (cond.results.length == isMatchingAll) {
        return obj.html;
      }
    }
  }
};

export const onCompletedShowProductsBR = onCompletedShowProductsDL;

export const onCompletedShowProductsKW = () => {
  for (
    let i = 0;
    i < settings.form[node.ONCOMPLETED.SHOWPRODUCTS].length;
    i++
  ) {
    const obj = settings.form[node.ONCOMPLETED.SHOWPRODUCTS][i];
    log(obj, loggerStyle.lightgreen);
    const cond = splitCondition(obj.expression);
    if (cond) {
      if (settings.answersMap[cond[0]].length > 0) {
        var isMatching = false;
        log("condition type: " + cond[2], loggerStyle.big.greenOnYellow);
        if (cond[2] == "=")
          isMatching = sameMembers(settings.answersMap[cond[0]], cond[1]);
        if (cond[2] == "anyof")
          isMatching = containsAllMembers(
            settings.answersMap[cond[0]],
            cond[1]
          );
        if (isMatching) {
          return obj.html;
        }
      }
    }
  }
};
